class SwiperElement extends HTMLElement {
  constructor() {
    super();
    this.configs = this.dataset.configs ? JSON.parse(this.dataset.configs) : {};
    this.enableMobile = this.dataset.mobile === "true" ? true : false;
    this.enableDekstop = this.dataset.desktop === "true" ? true : false;
    this.sections = this.querySelectorAll(".shopify-section");
    this.sectionsIsHiddenOnMobile = [];
    this.sectionsIsHiddenOnDesktop = [];
    this.isMobile = window.innerWidth < 1024;
  }
  connectedCallback() {
    if (this.sections[0]?.querySelector(".banner-section video")) {
      this.sections[0].querySelector(".banner-section video").play();
    }
    if (
      (window.innerWidth < 1024 && this.enableMobile) ||
      (window.innerWidth >= 1024 && this.enableDekstop)
    ) {
      this.querySelectorAll('[data-show="desktop"]').forEach((it) => {
        this.sectionsIsHiddenOnDesktop.push(it.parentElement.cloneNode(true));
        if (window.innerWidth < 1024 && this.enableMobile) {
          it.parentElement.remove();
        }
      });
      this.querySelectorAll('[data-show="mobile"]').forEach((it) => {
        this.sectionsIsHiddenOnMobile.push(it.parentElement.cloneNode(true));
        if (window.innerWidth >= 1024 && this.enableDekstop) {
          it.parentElement.remove();
        }
      });
      const swiper = new Swiper(this, this.configs);
      swiper.on("slideChange", function (e) {
        var activeElement = e.slides[e.activeIndex];
        if (
          activeElement.classList.contains("banner-section") ||
          activeElement.classList.contains("index-section--hero")
        ) {
          document.querySelector("header").classList.add("color-light");
          activeElement.querySelector("video")?.play();
        } else {
          document.querySelector("header").classList.remove("color-light");
        }
      });
      if(this.classList.contains('homeSwiper')){
        window.addEventListener("resize", this.resizeWindow.bind(this));
      }
    }
  }
  resizeWindow() {
    if (!document.body.classList.contains("template-index")) return false;
    if (this.isMobile && window.innerWidth >= 1024) {
      this.sectionsIsHiddenOnMobile = [];
      this.querySelectorAll('[data-show="mobile"]').forEach((it,idx) => {
        this.sectionsIsHiddenOnMobile.push(it.parentElement.cloneNode(true));
        it.parentElement.remove();
      });
      this.sectionsIsHiddenOnDesktop.reverse().forEach(el => {
        this.querySelector(".swiper-wrapper").insertBefore(
          el,
          this.querySelector(".swiper-wrapper").children[1],
        );
      })
    }
    if (!this.isMobile && window.innerWidth < 1024) {
      this.sectionsIsHiddenOnDesktop = [];
      this.querySelectorAll('[data-show="desktop"]').forEach((it) => {
        this.sectionsIsHiddenOnDesktop.push(it.parentElement.cloneNode(true));
        it.parentElement.remove();
      });
      this.sectionsIsHiddenOnMobile.reverse().forEach(el => {
        this.querySelector(".swiper-wrapper").insertBefore(
          el,
          this.querySelector(".swiper-wrapper").children[1],
        );
      })
    }
    this.isMobile = window.innerWidth < 1024;
  }
}
customElements.define("swiper-element", SwiperElement);